import { Trans } from '@lingui/macro';

const hardcodedIsExpress = (routeNumber?: string | null) => {
  if (routeNumber == null) return false;

  const expressNumbers = ['100', '101'];
  const result = expressNumbers.includes(routeNumber);

  return result;
};

type RefundFeeExpressProps = {
  routeNumber?: string | null;
};
export const RefundFeeExpress = ({ routeNumber }: RefundFeeExpressProps) => {
  const isExpress = hardcodedIsExpress(routeNumber);

  if (!isExpress) return null;

  return (
    <>
      <p style={{ margin: '0 0 8px' }}>
        <Trans>
          При возврате билета за <b>24</b> часа до отправления поезда от
          стоимости билета с пассажира удерживается <b>300</b> драм.
        </Trans>
      </p>
      <p style={{ margin: '0 0 8px' }}>
        <Trans>
          При возврате билета за <b>6</b> часов до отправления поезда от
          стоимости билета с пассажира удерживается <b>500</b> драм.
        </Trans>
      </p>
      <p style={{ margin: '0 0 8px' }}>
        <Trans>
          При возврате билета за <b>1</b> час до отправления поезда от стоимости
          билета с пассажира удерживается <b>750</b> драм.
        </Trans>
      </p>
      <p style={{ margin: 0 }}>
        <Trans>
          За <b>20</b> минут до отправления поезда билет возврату не подлежит.
        </Trans>
      </p>
    </>
  );
};
